import React from 'react';
import Propagator from '../../Propagator';
import { Mutation } from 'react-apollo';
import gql from 'graphql-tag';

const UPDATE_SESSION_DATES_MUTATION = gql`
	mutation($sessionID: ID!, $startDate: String, $endDate: String) {
		updateSessionDates(
			sessionID: $sessionID
			startDate: $startDate
			endDate: $endDate
		)
	}
`;

export default ({ children }) => (
	<Mutation mutation={UPDATE_SESSION_DATES_MUTATION} refetchQueries={['adminQuery', 'sessionQuery']}>
		{updateSessionDates => Propagator(children, updateSessionDates)}
	</Mutation>
);
